export default {
  computed: {
    $_isAppInstalled() {
      // For iOS
      if (window.navigator.standalone) return true
      // For Android
      if (window.matchMedia('(display-mode: standalone)').matches) return true
      // If neither is true, it's not installed
      return false
    },
    $_clientMode() {
      return this.$store.getters.getClientMode
    },
    $_kioskMode() {
      return this.$store.getters.getClientMode === 'kiosk' ? true : false
    },
    $_colsWidth() {
      if (this.$vuetify.breakpoint.xl) {
        console.log('%c Size XL ', 'font-style: italic;; color: grey')
        return 2
      } else if (this.$vuetify.breakpoint.lg) {
        console.log('%c Size LG ', 'font-style: italic;; color: grey')
        return 3
      } else if (this.$vuetify.breakpoint.md) {
        console.log('%c Size MD ', 'font-style: italic;; color: grey')
        return 4
      } else if (this.$vuetify.breakpoint.sm) {
        console.log('%c Size SM ', 'font-style: italic;; color: grey')
        return 6
      } else if (this.$vuetify.breakpoint.xs) {
        console.log('%c Size XS ', 'font-style: italic;; color: grey')
        return 12
      } else {
        return 12
      }
    }
  },
  methods: {
    $_getImage(imageId) {
      if (imageId)
        return `${process.env.VUE_APP_IMAGE_BACKEND}/870/${imageId}.jpg`
      else {
        const fallBackImages = ['2476', '2278', '2010', '2377']
        const fallBackImage =
          fallBackImages[Math.floor(Math.random() * fallBackImages.length)]
        return `${process.env.VUE_APP_IMAGE_BACKEND}/870/${fallBackImage}.jpg`
      }
    },
    $_removeOldPrefix(text) {
      if (!text) return ''
      const res = text.replaceAll(
        'https://www.havet.nu/livet',
        process.env.VUE_APP_BASE_URL
      )
      // return process.env.VUE_APP_BASE_URL + correctUrl
      return res
    }
  },
  filters: {
    $_ellipsis(text, wordCount) {
      if (!text) return ''
      const arrWords = text.split(' ')
      return arrWords.slice(0, wordCount).join(' ')
    }
  }
}
